import { httpClient } from "@/lib/http-client"

export class Project {
  constructor(id: string, name: string, siteId: string, priorityCodeId: string, stageCodeId: string, staffDays: number, cost: number, startDate: string | null, endDate: string | null) {
    this.id = id
    this.name = name
    this.siteId = siteId
    this.priorityCodeId = priorityCodeId
    this.stageCodeId = stageCodeId
    this.staffDays = staffDays
    this.cost = cost
    this.startDate = startDate
    this.endDate = endDate
  }

  id: string
  name: string
  siteId: string
  priorityCodeId: string
  stageCodeId: string
  staffDays: number
  cost: number
  startDate: string | null
  endDate: string | null
}

export class ProjectService {
  private static readonly BASE_PATH = "/api/projects"

  static getById(projectId: string): Promise<Project> {
    return httpClient.get<Project>(`${this.BASE_PATH}/${projectId}`)
  }

  static create(project: Project): Promise<Project> {
    return httpClient.post<Project>(`${this.BASE_PATH}`, project)
  }  

  static update(projectId: string, project: Project): Promise<void> {
    return httpClient.put<void>(`${this.BASE_PATH}/${projectId}`, project)
  }

  static getBySiteId(siteId: string): Promise<Project[]> {
    return httpClient.get<Project[]>(`${this.BASE_PATH}/site/${siteId}`)
  }

  static delete(projectId: string): Promise<void> {
    return httpClient.delete<void>(`${this.BASE_PATH}/${projectId}`)
  }
}